var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12719 11.5825C9.47719 11.7125 9.85719 11.7925 10.2472 11.7925C12.0372 11.7925 13.4972 10.3325 13.4972 8.54249C13.4972 7.69249 13.1572 6.91249 12.6172 6.33249L9.11719 11.5725L9.12719 11.5825Z",
    fill: "#FFD700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.248 5.2925C8.45805 5.2925 6.99805 6.7525 6.99805 8.5425C6.99805 9.3925 7.33805 10.1725 7.87805 10.7525L11.378 5.5125C11.028 5.3825 10.648 5.3025 10.258 5.3025L10.248 5.2925Z",
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.248 0.792496H4.24805C2.17805 0.792496 0.498047 2.4725 0.498047 4.5425V12.5425C0.498047 14.6125 2.17805 16.2925 4.24805 16.2925H16.248C18.318 16.2925 19.998 14.6125 19.998 12.5425V4.5425C19.998 2.4725 18.318 0.792496 16.248 0.792496ZM10.248 13.2925C7.62805 13.2925 5.49805 11.1625 5.49805 8.5425C5.49805 5.9225 7.62805 3.7925 10.248 3.7925C12.868 3.7925 14.998 5.9225 14.998 8.5425C14.998 11.1625 12.868 13.2925 10.248 13.2925Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShowIcon);
export default __webpack_public_path__ + "static/media/no-show-icon.0a5152432a44966ed6ec48f94f99710e.svg";
export { ForwardRef as ReactComponent };